const initDoc = require('./initDoc')

module.exports = {
  initDoc,
}
